module.exports = __webpack_public_path__ + "img/calendar_icon.938c3404.svg";